export default __webpack_public_path__ + "static/Dana_V1@2x-e8a35354bafc25631d078ec05aec25fe.png";